import { StyledPropType } from 'style-utils/core/core.types';
import { createExtractCssFromProps } from 'style-utils/core/createExtractCssFromProps/createExtractCssFromProps';
import { getNestedPropertyOrDefault } from 'style-utils/core/createExtractCssFromProps/utils/getNestedPropertyOrDefault';
import { isNumber } from 'utils/functions/isNumber';

const getWidth = (n: StyledPropType, scale: object) =>
  getNestedPropertyOrDefault(
    scale,
    n,
    !isNumber(n) || (n as number) > 1 ? n : (n as number) * 100 + '%',
  );

const widthMappedProperties = {
  w: {
    property: 'width',
    transform: getWidth,
  },
  minW: {
    property: 'minWidth',
  },
  maxW: {
    property: 'maxWidth',
  },
};

export type WithWidthProps = Partial<
  Record<keyof typeof widthMappedProperties, StyledPropType>
>;

export const withWidth = createExtractCssFromProps(widthMappedProperties);
